<template>
  <div class="email-app-details">

    <!-- Email Header -->
    <div class="email-detail-header">

      <!-- Header: Left -->
      <div class="email-header-left d-flex align-items-center">
        <span class="go-back mr-1">
          <feather-icon
            :icon="$store.state.appConfig.isRTL ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
            size="20"
            class="align-bottom"
            @click="$emit('close-email-view')"
          />
        </span>
        <h4 class="email-subject mb-0">
          {{ emailViewData.descripcion }}
        </h4>
      </div>

      <!-- Header: Right -->
      <div class="email-header-right ml-2 pl-1">

        <!-- Mark Starred -->
        <!-- <feather-icon
          icon="StarIcon"
          size="17"
          class="cursor-pointer"
          :class="{ 'text-warning fill-current': emailViewData.isStarred }"
          @click="$emit('toggle-email-starred')"
        /> -->

        <!-- Move email to folder -->
        <!-- <b-dropdown
          variant="link"
          no-caret
          toggle-class="p-0"
          right
          class="ml-75"
        >
          <template #button-content>
            <feather-icon
              icon="FolderIcon"
              size="17"
            />
          </template>

          <b-dropdown-item @click="$emit('move-email-to-folder', 'draft')">
            <feather-icon icon="Edit2Icon" />
            <span class="align-middle ml-50">Draft</span>
          </b-dropdown-item>

          <b-dropdown-item @click="$emit('move-email-to-folder', 'spam')">
            <feather-icon icon="InfoIcon" />
            <span class="align-middle ml-50">Spam</span>
          </b-dropdown-item>

          <b-dropdown-item
            v-show="$route.params.folder !== 'trash'"
            @click="$emit('move-email-to-folder', 'trash')"
          >
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Trash</span>
          </b-dropdown-item>
        </b-dropdown> -->

        <!-- Update Label -->
        <!-- <b-dropdown
          variant="link"
          no-caret
          toggle-class="p-0"
          class="ml-75"
          right
        >
          <template #button-content>
            <feather-icon
              icon="TagIcon"
              size="17"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item @click="$emit('update-email-label', 'personal')">
            <span class="mr-50 bullet bullet-success bullet-sm" />
            <span>Personal</span>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('update-email-label', 'company')">
            <span class="mr-50 bullet bullet-primary bullet-sm" />
            <span>Company</span>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('update-email-label', 'important')">
            <span class="mr-50 bullet bullet-warning bullet-sm" />
            <span>Important</span>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('update-email-label', 'private')">
            <span class="mr-50 bullet bullet-danger bullet-sm" />
            <span>Private</span>
          </b-dropdown-item>
        </b-dropdown> -->

        <!-- Mark Un-Read -->
        <feather-icon
          icon="MailIcon"
          class="ml-75 cursor-pointer"
          size="17"
          @click="$emit('mark-email-unread')"
        />

        <!-- Move to Trash -->
        <feather-icon
          v-show="$route.params.folder !== 'trash'"
          icon="TrashIcon"
          class="ml-75"
          size="17"
          @click="$emit('move-email-to-folder', 'trash')"
        />

        <!-- Show Previous Mail -->
        <feather-icon
          :icon="$store.state.appConfig.isRTL ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
          size="17"
          class="ml-75 cursor-pointer"
          :class="{'text-muted pointer-events-none': !opendedEmailMeta.hasPreviousEmail}"
          @click="$emit('change-opened-email', 'previous')"
        />

        <!-- Show Next Mail -->
        <feather-icon
          :icon="$store.state.appConfig.isRTL ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
          size="17"
          class="ml-75 cursor-pointer"
          :class="{'text-muted pointer-events-none': !opendedEmailMeta.hasNextEmail}"
          @click="$emit('change-opened-email', 'next')"
        />
      </div>
    </div>

    <!-- Email Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="email-scroll-area scroll-area"
    >

      <!-- Label Row -->
      <b-row>
        <b-col cols="12">
          <div class="email-label">
            <b-badge
              v-for="(label) in emailViewData.labels"
              :key="label"
              pill
              class="text-capitalize mr-50"
              :variant="`light-${resolveLabelColor(label)}`"
            >
              {{ label }}
            </b-badge>
          </div>
        </b-col>
      </b-row>

      <!-- Action: Show Earlier Message -->
      <b-row
        v-if="!showWholeThread && emailViewData.replies && emailViewData.replies.length"
        class="mb-1"
      >
        <b-col cols="12">
          <b-link
            class="font-weight-bold"
            @click="showWholeThread = true"
          >
            View {{ emailViewData.replies.length }} Earlier Message{{ emailViewData.replies.length > 1 ? 's' : '' }}
          </b-link>
        </b-col>
      </b-row>

      <!-- Earlier Email Messages -->
      <template v-if="showWholeThread">
        <b-row
          v-for="threadMail in emailViewData.replies.slice().reverse()"
          :key="threadMail.id"
        >
          <b-col cols="12">
            <email-message-card :message="threadMail" />
          </b-col>
        </b-row>
      </template>

      <!-- Email Actions: Reply or Forward -->
      <b-row>
        <b-col
          sm="11"
        >
          <b-card>
            <div class="d-flex justify-content-between">
              <h5
                class="mb-0"
                style="text-align: center;"
              >
                VISOR DE MAPA DE PARCELAS
              </h5>
              <label
                v-show="false"
                for="file"
                class="btn btn-outline-success"
              >
                <feather-icon
                  icon="FileTextIcon"
                  class="mr-50"
                />
                Importarddd
              </label>
              <input
                v-show="false"
                id="file"
                type="file"
                @change="onChange"
              >
            </div>
            <b-card-body>
              <div class="row">
                <div class="col-sm-12">
                  <google-map
                    v-if="mapEnabled"
                    :latitude="latitude"
                    :longitude="longitude"
                    title="Título de Marcador"
                    :data-parcela.sync="dataParcela"
                  />
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <div class="d-flex justify-content-between">
              <h5 class="mb-0">
                Lista de coordenadas
              </h5>
            </div>
            <br>
            <div>
              <div
                v-for="item in dataParcela.parcelaCoordenada"
                :key="item.idParcelaCoordenada"
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <ul>
                  <li
                    style="font-size:12px; font-family: sans-serif;"
                  >
                    Latitud: {{ item.latitud }} Longitud: {{ item.latitud }}
                  </li>
                </ul>
                <!-- <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-2">
                      - Lat: {{ item.latitud }} Lng: {{ item.latitud }}
                    </h6>
                  </b-media-body>
                </b-media> -->
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BRow, BCol, BBadge, BCard, BLink, BCardBody,
} from 'bootstrap-vue'
import XLSX from 'xlsx'
import { _ } from 'vue-underscore'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ref, watch } from '@vue/composition-api'
import useEmail from './useEmail'
import GoogleMap from './GoogleMap.vue'

export default {
  components: {

    // BSV
    BRow,
    BCol,
    BBadge,
    BCard,
    BLink,
    BCardBody,
    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    GoogleMap,
  },
  props: {
    emailViewData: {
      type: Object,
      required: true,
    },
    opendedEmailMeta: {
      type: Object,
      required: true,
    },
    mapEnabled: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const { resolveLabelColor } = useEmail()
    const latitude = ref(-6.0220945)
    const longitude = ref(-76.9884157)
    const dataParcela = ref({})
    const mapEnabledMap = ref(false)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }
    const showWholeThread = ref(false)
    watch(() => props.emailViewData.id, () => {
      showWholeThread.value = false
    })
    /* const loadStatus = async (status, data) => {
      mapEnabledMap.value = status
      dataParcela.value = data
    } */
    return {

      // UI
      perfectScrollbarSettings,
      showWholeThread,
      latitude,
      longitude,
      dataParcela,
      // loadStatus,
      mapEnabledMap,
      // useEmail
      resolveLabelColor,
    }
  },
  data: () => ({
    items: [],
    paths: [],
    latitude: -6.0220945,
    longitude: -76.9884157,
    title: 'Título de Marcador',
    dataParcela: {},
    mapEnabledMap: false,
  }),
  methods: {
    async onChange(event) {
      this.$swal({
        title: '¿Está seguro?',
        text: 'Yasss!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.viewPoints(event)
        }
      })
    },
    viewPoints(event) {
      this.mapEnabled = false
      const file = event.target.files ? event.target.files[0] : null // files[0]
      if (file) {
        const fileReader = new FileReader()
        fileReader.onload = e => {
          let binary = ''
          const bytes = new Uint8Array(e.target.result)
          const length = bytes.byteLength
          for (let i = 0; i < length; i += 1) {
            binary += String.fromCharCode(bytes[i])
          }
          const workbook = XLSX.read(binary, { type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy;@' })
          const sheetNameList = workbook.SheetNames
          this.paths = []
          this.items = []
          sheetNameList.forEach(y => {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[y])
            this.paths = []
            this.items = []
            if (roa.length > 0) {
              roa.forEach(dat => {
                const lat = _.isUndefined(dat.LATITUD) ? 0 : parseFloat(dat.LATITUD)
                const lng = _.isUndefined(dat.LONGITUD) ? 0 : parseFloat(dat.LONGITUD)
                this.paths.push({
                  latitud: lat,
                  longitud: lng,
                })
                this.items.push({
                  latitud: lat,
                  longitud: lng,
                })
              })
              this.dataParcela = {
                descripcion: 'Parcela Importada',
                parcelaCoordenada: this.paths,
              }
              this.mapEnabled = true
            }
          })
        }
        fileReader.readAsArrayBuffer(file)
      }
    },
  },
}
</script>

<style>

</style>
